import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames/bind";
import css from "./SubContent.scss";

const cx = classnames.bind(css);
const moduleName = "SubContent";

const CARDS = [
  {
    to: "/surrounding",
    label: "주변전경",
    desc: "펜션 바로 옆 강과 법흥계곡, 뛰어난 자연 속으로",
    bg: "url(" + require("../assets/Main_subcontent.jpeg") + ")",
  },
  {
    to: "/room",
    label: "객실소개",
    desc: "창밖으로 펼쳐지는 산과 강의 풍경이 함께하는 객실",
    bg: "url(" + require("../assets/Main_subcontent2.jpeg") + ")",
  },
  {
    to: "/board",
    label: "추억만들기",
    desc: "소중한 순간들을 담은 손님들의 이야기",
    bg: "url(" + require("../assets/Main_subcontent3.jpeg") + ")",
  },
  {
    to: "/facility",
    label: "부대시설",
    desc: "족구장, 축구장, 가마솥 체험 등 다양한 시설",
    bg: "linear-gradient(135deg, #265E4B 0%, #1A2E25 100%)",
  },
];

const SubContent = () => (
  <section className={cx(moduleName)}>
    <div className={cx(`${moduleName}-intro`)} data-aos="fade-up">
      <p className={cx(`${moduleName}-intro-label`)}>Murung Family Pension</p>
      <h2 className={cx(`${moduleName}-intro-title`)}>
        자연과 함께하는<br />특별한 하루
      </h2>
      <p className={cx(`${moduleName}-intro-desc`)}>
        맑은 공기, 탁 트인 전망, 그리고 따뜻한 환대.
        <br />스테이 무릉도원에서 잊지 못할 추억을 만들어 가세요.
      </p>
    </div>

    <div className={cx(`${moduleName}-grid`)}>
      {CARDS.map((card, i) => (
        <Link to={card.to} key={i} className={cx(`${moduleName}-card`)} data-aos="fade-up" data-aos-delay={i * 80}>
          <div
            className={cx(`${moduleName}-card-bg`)}
            style={{ backgroundImage: card.bg }}
          />
          <div className={cx(`${moduleName}-card-overlay`)} />
          <div className={cx(`${moduleName}-card-content`)}>
            <h3 className={cx(`${moduleName}-card-label`)}>{card.label}</h3>
            <p className={cx(`${moduleName}-card-desc`)}>{card.desc}</p>
            <span className={cx(`${moduleName}-card-arrow`)}>→</span>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

export default SubContent;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Main/components/SubContent.jsx